import { WeekBase } from '../../shared/models/week-base';
import type { IGame } from '../../shared/interfaces/IGame';
import { Enumerable } from '../../shared/linq';
import { Series } from '../../shared/models/series';

/**
 * NBA Week.
 * - Series is initialized in constructor (same as WeekBase but explicit for clarity).
 * - GamesComputed: simple ascending sort by SortOrder, then by home TeamAbbreviation.
 *   This is the base WeekBase default — NBA uses epoch-based SortOrder so ascending is correct.
 */
export class NbaWeek extends WeekBase {
  constructor(Division: string) {
    super(Division);
    // Series is already initialized in WeekBase constructor
  }

  /** NBA uses simple ascending sort by SortOrder (epoch), then home team abbreviation. */
  protected override createGamesComputed(): KnockoutObservable<IGame>[] {
    const self = this;
    return Enumerable.From(self.games())
      .OrderBy((p: KnockoutObservable<IGame> | IGame) => {
        if (typeof p === 'function') {
          return (p as KnockoutObservable<IGame>)().SortOrder();
        }
        return (p as IGame).SortOrder();
      })
      .ThenBy((p: KnockoutObservable<IGame> | IGame) => {
        if (typeof p === 'function') {
          return (p as KnockoutObservable<IGame>)().home().TeamAbbreviation;
        }
        return (p as IGame).home().TeamAbbreviation;
      })
      .ToArray() as KnockoutObservable<IGame>[];
  }
}

// Re-export Series so schedule-picker can use it without importing from shared directly
export { Series };
